export interface ReelFilters {
  category?: string;
  city?: string;
  /**
   * Asked for explicitly because the API's own default is 24, and the
   * catalogue had already reached it. The page filters and pages over what
   * this returns, so it has to be the whole set, not the first screen of it.
   */
  limit?: number;
  /** Page language: titles, category and city names come back in it. */
  lang?: string;
}

export const reelsKeys = {
  all: ["reels"] as const,
  list: (filters?: ReelFilters) =>
    [...reelsKeys.all, "list", filters] as const,
};
